import script from "./AssetChangeLog.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetChangeLog.vue?vue&type=script&setup=true&lang=js"

import "./AssetChangeLog.vue?vue&type=style&index=0&id=39603c05&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39603c05"]])

export default __exports__